import axios from "..";
import { ComputedReport, NewReport } from "../../types";
import { ComputeReportPayload } from "../../store";

export const listReports = (): Promise<NewReport[]> => axios.get("/report");
export const computeReport = (payload: ComputeReportPayload): Promise<ComputedReport> =>
  axios.post("/report/compute", payload);
export const createReport = (payload: NewReport): Promise<void> => axios.post("/report", payload);
